import React from 'react';

import { AvatarList } from 'src/components/ui/AvatarList';
import type { Medium } from 'src/types/__generated__/graphql';

type CollaboratorData = {
    id: string;
    fullName: string;
    initials: string;
    image: Pick<Medium, 'url'> | null;
};

export type GalleryCollaborator = {
    user?: {
        id: string;
        fullName?: string | null;
        initials?: string | null;
        image?: Pick<Medium, 'url'> | null;
    } | null;
    company?: {
        id: string;
        name?: string | null;
        initials?: string | null;
        image?: Pick<Medium, 'url'> | null;
    } | null;
};

type Props = {
    collaborators: GalleryCollaborator[];
    additionalCollaboratorsCount?: number;
    avatarSize?: number;
    avatarOverlapMargin?: string;
    showAddUserButton?: boolean;
    onAddUserClick?: () => void;
};

export const CollaboratorsAvatarList: React.FC<Props> = ({
    collaborators,
    additionalCollaboratorsCount,
    avatarSize = 20,
    avatarOverlapMargin = '0.55rem',
    showAddUserButton,
    onAddUserClick,
}) => {
    const collaboratorsData: CollaboratorData[] = collaborators
        .map((collaborator) => {
            const id = collaborator.user?.id ?? collaborator.company?.id;
            const name = collaborator.user?.fullName ?? collaborator.company?.name;
            const image = collaborator.user?.image ?? collaborator.company?.image;
            const initials = collaborator.user?.initials ?? collaborator.company?.initials;

            if (!id) {
                return null;
            }

            return {
                id,
                fullName: name,
                image,
                initials,
            };
        })
        .filter<CollaboratorData>((c): c is CollaboratorData => Boolean(c));

    return (
        <AvatarList
            users={collaboratorsData}
            additionalUsersCount={additionalCollaboratorsCount}
            avatarSize={avatarSize}
            overlapMargin={avatarOverlapMargin}
            showAddUserButton={showAddUserButton}
            onAddUserClick={onAddUserClick}
        />
    );
};
